import { Component, OnInit } from '@angular/core';

import { ForecastService } from '../forecast.service';
import * as moment from 'moment';

declare var $: any; //jQuery

@Component({
  selector: 'app-cities',
  templateUrl: './cities.component.html',
  styleUrls: ['./cities.component.css']
})
export class CitiesComponent implements OnInit {

  // list of cities
  cities = [{
    "Name" : "Atlanta, Georgia",
    "Zipcode": "30324"
  },{
    "Name" : "Boston, Massachusetts",
    "Zipcode" : "02108"
  },{
    "Name" : "Dallas, Texas",
    "Zipcode" : "75202"
  },{
    "Name" : "Denver, Colorado",
    "Zipcode" : "80204"
  },{
    "Name" : "Henrietta, New York",
    "Zipcode": "14467"
  },{
    "Name" : "Hudson, New Hampshire",
    "Zipcode" : "03051"
  },{
    "Name" : "Miami, Florida",
    "Zipcode" : "33111"
  },{
    "Name" : "Newark, New Jersey",
    "Zipcode" : "07101"
  },{
    "Name" : "San Diego, California",
    "Zipcode" : "92101"
  },{
    "Name" : "Seattle, Washington",
    "Zipcode" : "98102"
  }];
    
  cityZipCode: String = this.cities[0]["Zipcode"];

  // forecast data
  forecastInfo = {};  
  
  lat: number;
  lng: number;  

  constructor(private forecastService: ForecastService) {    
   }

  ngOnInit() { 
    this.getWeatherData();    
  }
  
  /*
   * GET the weather data using the Forecast service
   * Shows forecast for five days
  */
  getWeatherData(): void {       
    // call the forecast service to get the weather data
    this.forecastService.getForecastByZip(this.cityZipCode)
      .subscribe(result => {        
        this.forecastInfo["location"] = result["city"]["coord"];
        this.lat = result["city"]["coord"]["lat"];
        this.lng = result["city"]["coord"]["lon"];        
        this.forecastInfo["cityName"] = result["city"]["name"];
        this.forecastInfo["country"] = result["city"]["country"]; 
        let tomorrow = moment().add(1,'days').set({hour:12,minute:0,second:0}).format('YYYY-MM-DD HH:mm:ss'); 
        let weatherArr = [];          
        let isFound: Boolean = false;
        this.forecastInfo["forecastData"] = [];
        for(let i=0,len=result["list"].length; i<len;i++){
          let weather = result["list"][i];            
          if(!isFound && weather["dt_txt"] === tomorrow){              
            isFound = true;              
            this.populateWeatherData(weatherArr, weather);              
            i+=7;               
          } else if(isFound){
            this.populateWeatherData(weatherArr, weather);
            i+=7;
            if(i>len && weatherArr.length<5){
              i=len-2;
            }
          }
        }        
      });      
  }

  /**
   * populate the result from weather API to the result object
   * @param currentArr: an array of objects
   * @param weatherObj: the object containing forecast data retrieved from the API 
   */  
  populateWeatherData(currentArr, weatherObj): void {
    let k = currentArr.length;
    currentArr[k] = {};    
    currentArr[k]["time"] = moment(weatherObj["dt_txt"]).format('ddd, MMM D'); //moment to format the dates
    currentArr[k]["temp"] = weatherObj["main"]["temp"]+"°F";
    currentArr[k]["minTemp"] = weatherObj["main"]["temp_min"]+"°F";
    currentArr[k]["maxTemp"] = weatherObj["main"]["temp_max"]+"°F";
    currentArr[k]["humidity"] = weatherObj["main"]["humidity"]+"%";              
    currentArr[k]["windSpeed"] = weatherObj["wind"]["speed"]+"mph";
    currentArr[k]["cloudiness"] = weatherObj["clouds"]["all"]+"%";
    currentArr[k]["description"] = weatherObj["weather"][0]["description"];
    currentArr[k]["iconUrl"] = "http://openweathermap.org/img/w/"+weatherObj["weather"][0]["icon"]+".png";
    this.forecastInfo["forecastData"].push(currentArr[k]);
  }

  /**
   * shows the location of the chosen city(googleMapsAPI)
   */
  showMap(): void {    
    $("#myModal").modal('show');
  }

}
